import { useRef, useEffect } from 'react'

const useUnmount = () => {
  const isUnmount = useRef(false)
  useEffect(() => {
    return () => isUnmount.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return [isUnmount]
}

export default useUnmount;